import {cn} from '@/lib/utils'
import {ExternalLink} from 'lucide-react'

interface Props {
  href: string
  className?: string
  children: React.ReactNode
  onClick?: () => void
}

export const NavigationExternalLink: React.FC<Props> = ({href, className, children, onClick}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    className={cn('inline-flex items-center gap-1.5', className)}
  >
    {children}
    <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-70" aria-hidden />
  </a>
)
